// A single floating tooltip for Home's charts. Tooltips here enhance and never
// gate: every value they show is also printed on the page or in the book table.
import { useCallback, useState } from "react";

export default function useHoverTip() {
  const [tip, setTip] = useState(null);

  const bind = useCallback((content) => ({
    onMouseEnter: (e) => setTip({ x: e.clientX, y: e.clientY, content }),
    onMouseMove: (e) => setTip({ x: e.clientX, y: e.clientY, content }),
    onMouseLeave: () => setTip(null),
  }), []);

  const el = tip ? (
    <div
      className="fixed z-[9999] pointer-events-none rounded-lg border border-[#3a3a3a] bg-[#2c2c2c] px-2.5 py-2 text-[12px] leading-snug text-[#f4f4f4] shadow-[0_8px_24px_rgba(0,0,0,0.45)]"
      style={{ left: Math.min(tip.x + 14, window.innerWidth - 280), top: tip.y + 14, maxWidth: 260 }}
    >
      {tip.content}
    </div>
  ) : null;

  return [el, bind];
}
